var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderopen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bases",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-folder{fill:#dcb67a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "folder.open") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u7F16\\u7EC4_",
    "data-name": "<\\u7F16\\u7EC4>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u590D\\u5408\\u8DEF\\u5F84_",
    "data-name": "<\\u590D\\u5408\\u8DEF\\u5F84>",
    className: "icon-folder",
    d: "M28,4a2,2,0,0,1,2,2V24a1.92,1.92,0,0,1-2,2V6H16l-2,4H6v6H22l6,10H6L0,16H4V10C4,8,6.47,8,6,8h7l2-4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderopen);
export default __webpack_public_path__ + "static/media/folder.open.0a3c803d387ce8b5fa5ce9b385e5ac8f.svg";
export { ForwardRef as ReactComponent };